import React, { Component } from 'react'
import AppPageMenu from './AppPageMenu'
import AppTitle from './AppTitle'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import AppCredentials from './AppCredentials'
import OAuth from './OAuth'
import AppEvents from './AppEvents'
import AppDisplayInfo from './AppDisplayInfo'
import AppInstallView from './AppInstallView'
import AppMonitor from './AppMonitor'
import AppAuthView from './AppAuthView'
import AppSubmitView from './AppSubmitView'
import { connect } from 'react-redux'
import { showTransientNotification } from '@driftt/traffic-control'
import { fetchApp } from 'api/developerApi'
import './style.css'


class AppPage extends Component {

  state = {
    isFetchingApp: true,
    app: {}
  }

  redirectToFirstScreen = () => {
    const id = this.resolveAppId()
    this.props.history.push(`/app/${id}/credentials`)
  }

  resolveAppId = () => {
    const { match } = this.props
    return match.params.id
  }

  fetchApp = () => {
    const appId = this.resolveAppId()
    const onDone = (app) => this.setState({ app })
    const onError = (error) => this.props.showErrorNotification('Ooops, something went wrong. Please refresh the page.')
    const onFinally = () => this.setState({ isFetchingApp: false })

    const onStateSet = () => fetchApp(appId)
      .then(onDone)
      .catch(onError)
      .then(onFinally)

    this.setState({ isFetchingApp: true }, onStateSet)
  }

  componentDidMount() {
      this.fetchApp()
  }

  render() {
    const appId = this.resolveAppId()
    const { app, isFetchingApp } = this.state
    const { showErrorNotification } = this.props

    return (
      <div className="app-page">
        <AppTitle appName={app.name || ""} />
        <div className="app-page-body">
          <AppPageMenu appId={appId} />
          <div className="app-page-content">
            <Switch>
              <Route path="/app/:id/credentials" render={props =>
                <AppCredentials appId={appId} showErrorNotification={showErrorNotification} />
              }/>
              <Route path="/app/:id/oauth" render={props =>
                <OAuth appId={appId} showErrorNotification={showErrorNotification} />
              }/>
              <Route path="/app/:id/events" render={props =>
                <AppEvents appId={appId} showErrorNotification={showErrorNotification} />
              }/>
              <Route path="/app/:id/info" render={props =>
                <AppDisplayInfo fetchApp={() => this.fetchApp()} app={app} appId={appId} showErrorNotification={showErrorNotification} isFetchingApp={isFetchingApp} />
              }/>
              <Route path="/app/:id/install" render={props =>
                <AppInstallView appId={appId} showErrorNotification={showErrorNotification} />
              }/>
              <Route path="/app/:id/monitor" render={props =>
                <AppMonitor appId={appId} showErrorNotification={showErrorNotification} />
              }/>
              <Route path="/app/:id/authorization" render={props =>
                <AppAuthView appId={appId} showErrorNotification={showErrorNotification} />
              }/>
              <Route path="/app/:id/submit" render={props =>
                <AppSubmitView appId={appId} showErrorNotification={showErrorNotification} />
              }/>
              <Redirect from="/app/:id" to={`/app/${appId}/info`} />
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = null
const mapDispatchToProps = dispatch => ({
  showErrorNotification: (message) => dispatch(showTransientNotification({ type: 'error', message }))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppPage))
